/** Require one continuous second at the requested visibility in an active tab. */
export function observeOfferVisibility(element: HTMLElement, onViewed: () => void, minimumRatio = 0.5): () => void {
  let visible = false;
  let done = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const cancel = () => { clearTimeout(timer); timer = undefined; };
  const update = () => {
    cancel();
    if (!done && visible && document.visibilityState === 'visible') {
      timer = setTimeout(() => {
        if (!element.isConnected || document.visibilityState !== 'visible') return;
        done = true;
        onViewed();
      }, 1000);
    }
  };
  const observer = new IntersectionObserver(([entry]) => {
    visible = entry.isIntersecting && entry.intersectionRatio >= minimumRatio;
    update();
  }, { threshold: [0, minimumRatio] });
  observer.observe(element);
  document.addEventListener('visibilitychange', update);
  return () => {
    cancel();
    observer.disconnect();
    document.removeEventListener('visibilitychange', update);
  };
}
